import { DEFAULT_DATA_POINT_RADIUS } from '../../constants.js';

export const DATA_POINT_OUTER_RADIUS = 6; // outer radius of the data point
export const GROUP_PADDING =
  DATA_POINT_OUTER_RADIUS - DEFAULT_DATA_POINT_RADIUS;
export const GROUP_DISTANCE_THRESHOLD = DATA_POINT_OUTER_RADIUS * 2; // distance between two groups
export const OVERLAY_PADDING = DATA_POINT_OUTER_RADIUS + 1;

export const BOTTOM_PADDING_ADJUSTMENT = 1; //APPDEV-9198 adjusts the excess of padding on the bottom to avoid cropping for labels or other elements in chart grid

export const HALF_PIXEL_CORRECTION = 1;
